import React, { Component } from 'react';
import WithTransition from '../../hoc/WithTransition';
import classNames from 'classnames';
import './dpit-multi-item-box.scss';


export default class MultiItemBox extends Component {

	constructor(props) {
		super(props);
		if (!this.props.externalState) {
			this.state = { opened: false };
		}
		this.timeout = null;
	}

	switchOpen = (open) => {
		if (this.timeout) clearTimeout(this.timeout);
		if (open !== this.isOpened()) {
			this.timeout = setTimeout(() => {
				this.timeout = null;
				this.setIsOpened(open);
			}, open ? 100 : 300);
		}
	};

	isOpened() {
		return this.props.externalState ? this.props.isOpened : this.state.opened;
	}

	setIsOpened(isOpened) {
		if (this.props.externalState && this.props.onOpenChange instanceof Function) {
			this.props.onOpenChange(isOpened);
		}
		else this.setState({ opened: isOpened });
	}

	render() {
		const menuEls = [];
		const isOpened = this.isOpened();

		React.Children.forEach(this.props.children, (child, i) => {
			const propsMod = {
				active: this.props.active
					&& child.props.active
					&& (i === 0 || (isOpened && !this.props.exiting && !this.props.openDisabled))
			};
			menuEls.push(
				<div key={i} className={this.props.classBEMRoot + '__item'}>
					{child.props.active != undefined ? React.cloneElement(child, propsMod) : child}
				</div>
			);
		});

		const mainClasses = classNames({
			[this.props.classBEMRoot]: true,
			[this.props.className]: this.props.className,
			[this.props.classBEMRoot + '--open-disabled']: this.props.openDisabled,
			[this.props.classBEMRoot + '--opened']: isOpened && !this.props.exiting,
			'dpit-pulse-once-2s': this.props.pulse,
			'dpit-pulse-infinite-2s': this.props.pulseInfinite,

		});
		return (
			<div
				className={mainClasses}
			>
				<div
					onMouseOver={() => this.switchOpen(true)}
					onMouseLeave={() => this.switchOpen(false)}
					onClick={this.props.onMenuSurroundingClick}
					className={classNames({
						[this.props.classBEMRoot + '__menu']: true,
						[this.props.classBEMRoot + '__menu--opened']: isOpened && !this.props.exiting
					})}
				>
					{menuEls}
				</div>
			</div>
		);
	}
}

export const MultiItemBoxWithTransition = WithTransition(MultiItemBox);
